import { render, staticRenderFns } from "./dynamic.vue?vue&type=template&id=0fd9c428&scoped=true&"
import script from "./dynamic.vue?vue&type=script&lang=js&"
export * from "./dynamic.vue?vue&type=script&lang=js&"
import style0 from "./dynamic.vue?vue&type=style&index=0&id=0fd9c428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd9c428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd9c428')) {
      api.createRecord('0fd9c428', component.options)
    } else {
      api.reload('0fd9c428', component.options)
    }
    module.hot.accept("./dynamic.vue?vue&type=template&id=0fd9c428&scoped=true&", function () {
      api.rerender('0fd9c428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/dynamic.vue"
export default component.exports